__turbopack_context__.v({
  "expiredConnectionsColumn": "AppsTable-module__tb1FYW__expiredConnectionsColumn",
});
